const defaultHeaders: HeadersInit = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export async function fetchPost(url: string, body: any, headers?: HeadersInit) {
  const response = await fetch(url, {
    method: 'POST',
    headers: headers ?? defaultHeaders,
    body,
  });
  if (!response.ok) throw new Error(response.statusText);
  return response;
}
